import { Minus } from "lucide-react";

type TransactionLayoutType = {
  transaction: any;
};

const BankTransactionLayout: React.FC<TransactionLayoutType> = ({
  transaction,
}: TransactionLayoutType) => {
  return (
    <div>
      <p>{transaction.receiver?.account_name}</p>
      <p>{transaction.receiver?.bank_name}</p>
      <p>{transaction.receiver?.account_number}</p>
    </div>
  );
};

const UserTransferLayout: React.FC<TransactionLayoutType> = ({
  transaction,
}: TransactionLayoutType) => {
  return (
    <div>
      <p>{transaction.receiver.name}</p>
      <p>#{transaction.receiver.username}</p>
    </div>
  );
};

const GetTransactionLayout: React.FC<TransactionLayoutType> = ({
  transaction,
}: TransactionLayoutType) => {
  switch (transaction.type) {
    case "bank_transfer":
    case "loan_repayment":
      return <BankTransactionLayout transaction={transaction} />;
    case "user_transfer":
    case "CashirANS_debit":
    case "CashirANS_credit":
    case "savings":
    case "loan":
    case "user_incenitive":
    case "fund_wallet":
      return <UserTransferLayout transaction={transaction} />;
    default:
      return <Minus />;
  }
};

export default GetTransactionLayout;
